<template>
  <div class="share-button-wrapper">
<!--
    <popper
      :append-to-body="true"
      ref="share-popper-content"
      trigger="clickToOpen"
      :options="{
        placement: 'bottom-end',
        //positionFixed: true
        modifiers: [{ offset: { offset: '0,0' } }],
      }"
    >
      <md-button
        class="md-button md-icon-button"
        slot="reference"
        ref="popperTrigger"
      >
        <md-icon>person_add_alt_1</md-icon>
      </md-button>

      <div class="popper">
        <div class="share-popper-content">
          <AssignedCreate :nid="nid"/>
        </div>
      </div>
    </popper>
-->
    <md-button
      class="md-button md-icon-button"
      @click="goToAssignedCreate()"
    >
      <md-icon>person_add_alt_1</md-icon>
    </md-button>


  </div>
</template>

<script>

import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import AssignedCreate from "@/AssignedCreate";

export default {
  name: "ShareButton",
  props: ["nid"],
  components: {
    Popper,
    AssignedCreate,
  },

  data() {
    return {
    };
  },
  methods: {
    goToAssignedCreate() {
      window.location.href = '/assigned/add/' + this.nid;
    },
  },
};
</script>

<style lang="scss" scoped>
.share-button-wrapper {
  .md-icon {
    display: block;
    .module-strategy &,
    .module-activity & {
      display: inline;
      color: rgba(255, 255, 255, 0.4)!important;
    }
  }
}

.popper {
  min-width: 600px;
  max-width: 600px;
  @media all and (max-width: $breakpoint-medium) {
    min-width: unset;
    width: 90%;
    z-index: 4 !important;
  }
  z-index: 100 !important;
  &.toolbar {
    min-width: 100px;
  }
  background-color: transparent;
  text-align: left;
  padding: 0px;
  border-radius: 0px;
  border: none;
  box-shadow: none;
  .popper-content {
    background-color: #ffffff;
    border-radius: 20px;
    box-shadow: 3px 3px 20px 2px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    .md-menu-content.md-select-menu {
      width: auto;
      max-width: none !important;
    }
  }
}

</style>
